export default __webpack_public_path__ + "static/media/icon_minus.69f52b0f.svg";